import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import templateContentDetailsAudioPageDetailsSubPage from "templates/contentDetailsAudioPageDetailsSubPage.hbs";

class ContentDetailsAudioPageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  get template() {
    return templateContentDetailsAudioPageDetailsSubPage;
  }
}

export default ContentDetailsAudioPageDetailsSubPageView;
